var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "property-color" }, [
    _c("div", {
      staticClass: "property-color__icon",
      class: _vm.icon,
      attrs: { title: _vm.readableName }
    }),
    _vm._v(" "),
    _vm.isReadOnly
      ? _c(
          "div",
          {
            staticClass: "property-color__input property-color__input--readonly"
          },
          [
            _c("div", {
              staticClass: "property-color__color-preview",
              style: { "background-color": _vm.selectedColor }
            })
          ]
        )
      : _c(
          "div",
          { staticClass: "property-color__input" },
          [
            _c(
              "ColorPicker",
              {
                attrs: {
                  value: _vm.selectedColor,
                  open: _vm.isColorPickerOpen
                },
                on: {
                  "update:open": function($event) {
                    _vm.isColorPickerOpen = $event
                  },
                  input: _vm.changeColor
                }
              },
              [
                _c("button", {
                  staticClass: "property-color__color-preview",
                  style: { "background-color": _vm.selectedColor }
                })
              ]
            ),
            _vm._v(" "),
            _vm.showColorRevertButton
              ? _c(
                  "Actions",
                  [
                    _c(
                      "ActionButton",
                      {
                        attrs: { icon: "icon-history" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.deleteColor($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(_vm.$t("calendar", "Remove color")) +
                            "\n\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }